import type { CreateDockerUrlType } from '../model/types';

import type { AxiosRequestConfig } from 'axios';
import { dockerToolInstance } from '@/shared/api/api-instances/docker-tool/api-instance';

export class DockerUrlsApi {
  static getUrls(options: AxiosRequestConfig = {}) {
    return dockerToolInstance.get<CreateDockerUrlType[]>('/docker_urls', {
      ...options,
    });
  }

  static testUrl(
    params: { docker_url: string },
    options: AxiosRequestConfig = {},
  ) {
    return dockerToolInstance.get<void>('/docker_url/connect/test', {
      ...options,
      params: params,
    });
  }

  static createUrl(
    payload: CreateDockerUrlType,
    options: AxiosRequestConfig = {},
  ) {
    return dockerToolInstance.post<void>('/docker_url', payload, {
      ...options,
    });
  }

  static changeUrlData(
    payload: { dockerUrlName: string; data: CreateDockerUrlType },
    options: AxiosRequestConfig = {},
  ) {
    return dockerToolInstance.put<void>(
      `/docker_url/${payload.dockerUrlName}`,
      payload.data,
      {
        ...options,
      },
    );
  }

  static deleteUrl(dockerName: string, options: AxiosRequestConfig = {}) {
    return dockerToolInstance.delete<void>(`/docker_url/${dockerName}`, {
      ...options,
    });
  }
}